import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import LogoImage from '../../../assets/images/helicap_logo.svg';
import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { RootState } from '../../../store/rootReducer';
import LoginActions from '../../login/redux/actions';
import { Aggrements } from '../../login/redux/types';
import { isNonAuthenticatedUrl } from '../../login/utils';
import { UserStatus } from '../../login/utils/Status';
import ContactUsModal from '../../main/deals/modal/ContactUs';
import UserAlret from '../../main/userAlret';
import { showOnlyLogout, showUnAuthenticated } from '../../utils/showButtons';
import HSButton from '../Button';
import HeaderMenu from './ActionMenu';
//import AnniversaryRebate from '../../bithdayPage';
import alertIcon from '../../../assets/images/alertIcon.svg';
import useIsTeamMember from '../../../hooks/useIsTeamMember';
import Footer from '../Footer';

const { Header, Content } = Layout;
const accessDenied = ['/referral'];

type Props = {
    type: 'Accreditation' | 'KYC';
};
export const KYCAIResubmission: React.FC<Props> = ({ type }) => {
    return (
        <div
            className="p-4 relative md:p-4 cursor-pointer md:py-2 mb-4 mt-2"
            style={{
                // boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,a
                backgroundColor: '#D6FDE6',
                border: '1px solid #27AE60',
            }}
        >
            <div className={`flex gap-2 md:items-center justify-start md:justify-center`}>
                <div className="w-9">
                    <img src={alertIcon} alt="alert" />
                </div>
                <p className="text-[#20222B] font-[Lato] text-sm">
                    Please note that your {type} information requires refreshing. Review the information below and amend
                    or re-submit documents as necessary.
                </p>
            </div>
        </div>
    );
};
const HeaderLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const isTeamMember: boolean = useIsTeamMember();
    //const { isShow } = useShowUserAlert(false);

    const [currentPath, setCurrentPath] = useState('');
    const [isVertical, setIsVertical] = useState(false);
    const [restart, setRestart] = useState(true);
    const [openContactUs, setContactUs] = useState(false);

    const jwtToken = useSelector((state: RootState) => state.user.jwtToken);
    const user = useSelector((state: RootState) => state.user.user);
    const investor = useSelector((state: RootState) => state.user.investor);

    const isActive = (name: string[]) => {
        let flag = false;
        name.forEach((n) => {
            if (currentPath.includes(n)) {
                flag = true;
            }
            if (n === '/deals' && currentPath === '/') {
                flag = true;
            }
        });
        return flag;
    };
    useEffect(() => {
        const handleScroll = () => {
            const header = document.getElementById('headerbar');
            if (header) {
                if (window.scrollY > 0) {
                    header.classList.add('header-shadow');
                } else {
                    header.classList.remove('header-shadow');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    /**Get current Path */
    useEffect(() => {
        if (isTeamMember && accessDenied.includes(location.pathname)) {
            navigate(HEADERMENU_PATH.accessDenied);
        }
        setCurrentPath(location.pathname);
    }, [location, isTeamMember, navigate]);

    /**Check is mobile view */
    useEffect(() => {
        if (window.innerWidth < 800) {
            setIsVertical(true);
        }
        if (restart) {
            setRestart(false);
        }

        function handleResize() {
            setIsVertical(window.innerWidth < 800 ? true : false);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [restart]);

    //Check postKYC or Account Activation
    useEffect(() => {
        if (
            !isNonAuthenticatedUrl(currentPath) &&
            user?.userProfile?.name &&
            user.userProfile.phoneNumber.number &&
            UserStatus.pendingActivation === user?.status &&
            currentPath !== HEADERMENU_PATH.accountActivationWithOtp
        ) {
            navigate(HEADERMENU_PATH.accountActivationWithOtp);
        }
    }, [currentPath, navigate, user]);

    /**Resign agreement */
    useEffect(() => {
        if (investor && jwtToken) {
            const nad: Aggrements | undefined = investor.agreements?.find((a) => a.agreementType === 'NDA');
            const aiConsent: Aggrements | undefined = investor.agreements?.find((a) => a.agreementType === 'AIConsent');
            const subscriptionAgreement: Aggrements | undefined = investor.agreements?.find(
                (a) => a.agreementType === 'SubscriptionAgreement',
            );
            const HIPLaiConsent: Aggrements | undefined = investor.agreements?.find(
                (a) => a.agreementType === 'HIPL AI Consent',
            );

            if (!isNonAuthenticatedUrl(currentPath) && !currentPath.includes(HEADERMENU_PATH.onboarding)) {
                if (nad && nad.shouldResign) {
                    navigate(HEADERMENU_PATH.resignNDA);
                    return;
                }
                if (aiConsent?.shouldResign) {
                    navigate(HEADERMENU_PATH.resignAIConsent);
                    return;
                }
                if (subscriptionAgreement?.shouldResign) {
                    navigate(HEADERMENU_PATH.resignSubscription);
                    return;
                }
                if (investor.isHIPL && HIPLaiConsent?.shouldResign) {
                    navigate(HEADERMENU_PATH.resignHIPLAIConsent);
                    return;
                }
            }
        }
    }, [currentPath, investor, jwtToken, navigate]);

    const logout = () => {
        dispatch(LoginActions.removeUserData());
        return navigate(HEADERMENU_PATH.login);
    };

    const redirectToPage = (url: string) => {
        return navigate(url);
    };

    return (
        <Layout id="Helicap" className={currentPath.includes('/deal/') ? 'bg-white' : ''}>
            <ContactUsModal type="General enquiry" open={openContactUs} setOpen={setContactUs} />
            <Header
                className="fixed w-full z-20 px-4 md:px-6 lg:px-16 xl:px-20 2xl:px-24 bg-white"
                id="headerbar"
                // style={{
                //     boxShadow: 'rgb(41 41 41 / 25%) 0px 0px 9px 3px',
                // }}
            >
                <div>
                    <img
                        src={LogoImage}
                        loading="lazy"
                        alt="imagelogo"
                        className="logo"
                        // style={isVertical ? { width: '50vw' } : {}}
                    />
                </div>
                <div>
                    {showUnAuthenticated(currentPath) && (
                        <>
                            {currentPath === HEADERMENU_PATH.login && (
                                <HSButton
                                    type="link"
                                    title="Sign Up"
                                    className="like_btn"
                                    onClick={() => redirectToPage(HEADERMENU_PATH.signUp)}
                                />
                            )}
                            {currentPath !== HEADERMENU_PATH.login && (
                                <HSButton
                                    type="link"
                                    title="Log In"
                                    className="like_btn"
                                    onClick={() => redirectToPage(HEADERMENU_PATH.login)}
                                />
                            )}
                        </>
                    )}
                    {showOnlyLogout(currentPath) && (
                        <HSButton type="link" title="Logout" className="like_btn" onClick={logout} />
                    )}
                    {!showUnAuthenticated(currentPath) && !showOnlyLogout(currentPath) && jwtToken && (
                        <>
                            {!isVertical && (
                                <div className="flex items-center">
                                    {desktopBtn.map((d, index) => {
                                        if (isTeamMember && d.title === 'Referral') {
                                            return <></>;
                                        }
                                        return (
                                            <HSButton
                                                type="link"
                                                title={d.title}
                                                key={`${index}_${d.title}`}
                                                className={`like_btn mx-2 ${
                                                    isActive(d.isActive) ? 'active_link_w' : 'inactive'
                                                }`}
                                                onClick={() => redirectToPage(d.URL)}
                                            />
                                        );
                                    })}
                                    <HeaderMenu
                                        setContactUs={setContactUs}
                                        isActive={isActive}
                                        isVertical={isVertical}
                                    />
                                </div>
                            )}
                            {isVertical && (
                                <HeaderMenu setContactUs={setContactUs} isActive={isActive} isVertical={isVertical} />
                            )}
                        </>
                    )}
                </div>
            </Header>
            <Content
                className={`site-layout h-full ${currentPath.includes('/deal/') && 'relative'} ${
                    currentPath.includes(HEADERMENU_PATH.settings) ||
                    currentPath === HEADERMENU_PATH.referral ||
                    currentPath === HEADERMENU_PATH.rebate ||
                    currentPath === HEADERMENU_PATH.investments
                        ? `mt-20 p-0 md:p-0`
                        : currentPath === HEADERMENU_PATH.deals || currentPath.includes('/deal/') || currentPath === '/'
                        ? 'mt-[80px]'
                        : 'mt-16 p-3 md:p-6'
                }`}
            >
                <div style={{ minHeight: `calc(100vh - 112px)` }}>
                    {!currentPath.includes(HEADERMENU_PATH.settings) &&
                        !currentPath.includes(HEADERMENU_PATH.investments) && <UserAlret />}
                    {/* {!currentPath.includes(HEADERMENU_PATH.referral) && currentPath !== HEADERMENU_PATH.rebate && (
                        <AnniversaryRebate />
                    )} */}
                    <Outlet />
                </div>
            </Content>
            <Footer />
        </Layout>
    );
};

export default HeaderLayout;

const desktopBtn = [
    {
        title: 'Deals',
        URL: HEADERMENU_PATH.deals,
        isActive: ['/deals'],
    },
    {
        title: 'Investments',
        URL: HEADERMENU_PATH.investments,
        isActive: ['/portfolio', '/repayment'],
    },
    {
        title: 'Referral',
        URL: HEADERMENU_PATH.referral,
        isActive: ['/referral'],
    },
];
